import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0bcd880e")

_pushScopeId("data-v-0bcd880e")
const _hoisted_1 = { class: "history" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_history_filters = _resolveComponent("history-filters")!
  const _component_s_pagination = _resolveComponent("s-pagination")!
  const _component_invoices_list = _resolveComponent("invoices-list")!
  const _component_arriving_invoices_list = _resolveComponent("arriving-invoices-list")!
  const _component_sended_invoices_list = _resolveComponent("sended-invoices-list")!
  const _component_orders_list = _resolveComponent("orders-list")!
  const _component_ftl_orders_list = _resolveComponent("ftl-orders-list")!
  const _component_ftl_bids_list = _resolveComponent("ftl-bids-list")!
  const _component_express_orders_list = _resolveComponent("express-orders-list")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_history_filters),
    (_ctx.isLTLInvoices && !Boolean(_ctx.LTLFiltersState.type))
      ? (_openBlock(), _createBlock(_component_invoices_list, {
          key: 0,
          title: "Мои накладные",
          loading: _ctx.LTLInvoicesData.state.is_loading,
          invoices: _ctx.LTLInvoicesData.data,
          onRefresh: _ctx.loadDataHandler,
          onMounted: _ctx.loadDataHandler,
          onExcel: _ctx.exportExcel
        }, {
          default: _withId(() => [
            _createVNode(_component_s_pagination, {
              "total-pages": _ctx.LTLInvoicesData.pagination.total_pages,
              value: _ctx.LTLInvoicesData.pagination.current_page,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.LTLInvoicesData.pagination.current_page = $event)),
              onChange: _ctx.loadDataHandler
            }, null, 8, ["total-pages", "value", "onChange"])
          ]),
          _: 1
        }, 8, ["loading", "invoices", "onRefresh", "onMounted", "onExcel"]))
      : _createCommentVNode("", true),
    (
                _ctx.isLTLInvoices &&
                Boolean(_ctx.LTLFiltersState.type) &&
                _ctx.LTLFiltersState.type.value === 'arriving'
            )
      ? (_openBlock(), _createBlock(_component_arriving_invoices_list, {
          key: 1,
          title: "Прибывающие накладные",
          loading: _ctx.LTLInvoicesData.state.is_loading,
          invoices: _ctx.LTLArrivingInvoicesData.data,
          onRefresh: _ctx.loadDataHandler
        }, {
          default: _withId(() => [
            _createVNode(_component_s_pagination, {
              "total-pages": _ctx.LTLArrivingInvoicesData.pagination.total_pages,
              value: _ctx.LTLArrivingInvoicesData.pagination.current_page,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.LTLArrivingInvoicesData.pagination.current_page = $event)),
              onChange: _ctx.loadDataHandler
            }, null, 8, ["total-pages", "value", "onChange"])
          ]),
          _: 1
        }, 8, ["loading", "invoices", "onRefresh"]))
      : _createCommentVNode("", true),
    (
                _ctx.isLTLInvoices &&
                Boolean(_ctx.LTLFiltersState.type) &&
                _ctx.LTLFiltersState.type.value === 'sended'
            )
      ? (_openBlock(), _createBlock(_component_sended_invoices_list, {
          key: 2,
          title: "Отправленные накладные",
          loading: _ctx.LTLInvoicesData.state.is_loading,
          invoices: _ctx.LTLSendedInvoicesData.data,
          onRefresh: _ctx.loadDataHandler
        }, {
          default: _withId(() => [
            _createVNode(_component_s_pagination, {
              "total-pages": _ctx.LTLSendedInvoicesData.pagination.total_pages,
              value: _ctx.LTLSendedInvoicesData.pagination.current_page,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.LTLSendedInvoicesData.pagination.current_page = $event)),
              onChange: _ctx.loadDataHandler
            }, null, 8, ["total-pages", "value", "onChange"])
          ]),
          _: 1
        }, 8, ["loading", "invoices", "onRefresh"]))
      : _createCommentVNode("", true),
    (_ctx.isLTLOrders)
      ? (_openBlock(), _createBlock(_component_orders_list, {
          key: 3,
          title: "Мои заказы",
          loading: _ctx.LTLOrdersData.state.is_loading,
          orders: _ctx.LTLOrdersData.data,
          onRefresh: _ctx.loadDataHandler,
          onMounted: _ctx.loadDataHandler
        }, {
          default: _withId(() => [
            _createVNode(_component_s_pagination, {
              "total-pages": _ctx.LTLOrdersData.pagination.total_pages,
              value: _ctx.LTLOrdersData.pagination.current_page,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.LTLOrdersData.pagination.current_page = $event)),
              onChange: _ctx.loadDataHandler
            }, null, 8, ["total-pages", "value", "onChange"])
          ]),
          _: 1
        }, 8, ["loading", "orders", "onRefresh", "onMounted"]))
      : _createCommentVNode("", true),
    (_ctx.isFTLOrders)
      ? (_openBlock(), _createBlock(_component_ftl_orders_list, {
          key: 4,
          title: "Мои FTL заказы",
          loading: _ctx.FTLOrdersData.state.is_loading,
          orders: _ctx.FTLOrdersData.data,
          onRefresh: _ctx.loadDataHandler,
          onMounted: _ctx.loadDataHandler,
          onExcel: _ctx.exportExcel
        }, {
          default: _withId(() => [
            _createVNode(_component_s_pagination, {
              "total-pages": _ctx.FTLOrdersData.pagination.total_pages,
              value: _ctx.FTLOrdersData.pagination.current_page,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (_ctx.FTLOrdersData.pagination.current_page = $event)),
              onChange: _ctx.loadDataHandler
            }, null, 8, ["total-pages", "value", "onChange"])
          ]),
          _: 1
        }, 8, ["loading", "orders", "onRefresh", "onMounted", "onExcel"]))
      : _createCommentVNode("", true),
    (_ctx.isFTLBids)
      ? (_openBlock(), _createBlock(_component_ftl_bids_list, {
          key: 5,
          title: "Мои FTL заявки",
          loading: _ctx.FTLBidsData.state.is_loading,
          bids: _ctx.FTLBidsData.data,
          onRefresh: _ctx.loadDataHandler,
          onMounted: _ctx.loadDataHandler,
          onExcel: _ctx.exportExcel
        }, {
          default: _withId(() => [
            _createVNode(_component_s_pagination, {
              "total-pages": _ctx.FTLBidsData.pagination.total_pages,
              value: _ctx.FTLBidsData.pagination.current_page,
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_ctx.FTLBidsData.pagination.current_page = $event)),
              onChange: _ctx.loadDataHandler
            }, null, 8, ["total-pages", "value", "onChange"])
          ]),
          _: 1
        }, 8, ["loading", "bids", "onRefresh", "onMounted", "onExcel"]))
      : _createCommentVNode("", true),
    (_ctx.isEXPRESS)
      ? (_openBlock(), _createBlock(_component_express_orders_list, {
          key: 6,
          title: "Доставка за 3 часа",
          loading: _ctx.ExpressOrdersData.state.is_loading,
          orders: _ctx.ExpressOrdersData.data,
          onRefresh: _ctx.loadDataHandler,
          onMounted: _ctx.loadDataHandler
        }, {
          default: _withId(() => [
            _createVNode(_component_s_pagination, {
              "total-pages": _ctx.ExpressOrdersData.pagination.total_pages,
              value: _ctx.ExpressOrdersData.pagination.current_page,
              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => (_ctx.ExpressOrdersData.pagination.current_page = $event)),
              onChange: _ctx.loadDataHandler
            }, null, 8, ["total-pages", "value", "onChange"])
          ]),
          _: 1
        }, 8, ["loading", "orders", "onRefresh", "onMounted"]))
      : _createCommentVNode("", true)
  ]))
})